/**
 * Сверка двух текстов по словам (карточка разговора стенда: текст модели ↔ расшифровка записи GigaAM).
 * Слова сравниваем без регистра, знаков и «ё»; общая часть — наибольшая общая подпоследовательность.
 */

export type DiffWord = { text: string; same: boolean };

const норма = (w: string) =>
  w
    .toLowerCase()
    .replace(/ё/g, "е")
    .replace(/[^\p{L}\p{N}]/gu, "");

/** Слова `a` и `b` с пометкой, есть ли слово в другом тексте на своём месте; `equal` — тексты совпали с
 * точностью до знаков и регистра. */
export function wordDiff(a: string, b: string): { a: DiffWord[]; b: DiffWord[]; equal: boolean } {
  const A = a.split(/\s+/).filter(Boolean);
  const B = b.split(/\s+/).filter(Boolean);
  const nb = B.map(норма);
  const na = A.map(норма);
  // LCS по нормализованным словам; реплики короткие — квадрат не страшен
  const dp: number[][] = Array.from({ length: na.length + 1 }, () => Array<number>(nb.length + 1).fill(0));
  for (let i = na.length - 1; i >= 0; i--)
    for (let j = nb.length - 1; j >= 0; j--)
      dp[i]![j] = na[i] === nb[j] && nb[j] ? dp[i + 1]![j + 1]! + 1 : Math.max(dp[i + 1]![j]!, dp[i]![j + 1]!);
  const same = new Set<number>();
  const sameA = new Set<number>();
  for (let i = 0, j = 0; i < na.length && j < nb.length; ) {
    if (na[i] === nb[j] && nb[j]) {
      same.add(j);
      sameA.add(i);
      i++;
      j++;
    } else if (dp[i + 1]![j]! >= dp[i]![j + 1]!) i++;
    else j++;
  }
  const значимыхA = na.filter(Boolean).length;
  const значимыхB = nb.filter(Boolean).length;
  return {
    a: A.map((text, i) => ({ text, same: !na[i] || sameA.has(i) })),
    b: B.map((text, j) => ({ text, same: !nb[j] || same.has(j) })),
    equal: same.size === значимыхB && значимыхB === значимыхA,
  };
}
